import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OptimUiSharedModule } from '../../shared/optimus-ui-shared.module';
@Component({
    selector: 'app-p404-component',
    templateUrl: '404.component.html',
    imports: [OptimUiSharedModule, CommonModule]
})
export class P404Component {

  constructor() { }

}
